import JwtService from "@/core/services/jwt.service";
import axios from '@/core/services';
import router from '@/router';

// action types
export const LOGIN = "login";
export const LOGOUT = "logout";
export const LOGOUTAUTH = "logoutAuth";
export const SETAUTH = "setauth";
export const REGISTER = "register";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    let user = state.user;
    if(!user || !user.recordId)
    {
      user = eval('(' + JwtService.getToken() + ')');
    }
    return user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve) => {
      const user = {};
      user.email = credentials.email;
      user.userPwd = credentials.password;
      user.cloud = "3";
      axios.fetchPost("hr/user/login", user).then(result => {
        if(result.data.result == "inexistence"){
          context.commit(SET_ERROR, ["inexistence"]);
        }else if (result.data.result == "fail"){
          context.commit(SET_ERROR, ["fail"]);
        }else if (result.data.result == "success"){
          context.commit(SET_AUTH, result.data.user);
          resolve(result.data.result);
        }else {
          context.commit(SET_ERROR, ["refresh"]);
        }
      }).catch(err => {context.commit(SET_ERROR, ["调用失败" + err]);});
    });
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve) => {
      const user = {};
      user.email = credentials.email;
      user.password = credentials.password;
      user.code = credentials.code;
      user.userName = credentials.userName;
      user.companyName = credentials.companyName;
      user.contractAdress = credentials.contractAdress;
      user.linkman = credentials.linkman;
      axios.fetchPost("hr/user/emailRegister", user).then(result => {
        if(result.data == "refresh"){
          context.commit(SET_ERROR, ["refresh"]);
        }else if (result.data == "repeat"){
          context.commit(SET_ERROR, ["repeat"]);
        }else if (result.data == "register"){
          context.commit(SET_ERROR, ["register"]);
        }else if (result.data == "success"){
          resolve(result.data);
        }else {
          context.commit(SET_ERROR, ["refresh"]);
        }
      }).catch(err => {context.commit(SET_ERROR, ["调用失败" + err]);});
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
    router.push("/login");
  },
  [LOGOUTAUTH](context) {
    context.commit(PURGE_AUTH);
  },
  [SETAUTH](context, user) {
    context.commit(SET_AUTH, user);
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    JwtService.saveToken(user);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
